<script>
    import Spinner from '~/components/Spinner.svelte';
    import InfiniteScroll from "svelte-infinite-scroll";

    import { slide } from 'svelte/transition';
    import { db, isAdmin } from '~/firebase';

    export let collection;
    export let where = [];
    export let limit = 5;

    let loading = false;
    let items = null;
    let reachedEnd = false;
    let nonce = 0;
    
    async function fetchData(includeHidden, clearItems) {
        nonce++;
        const token = nonce;
        loading = true;
        const ref = db.ref(collection);
        const query = ref.query()
            .orderBy('timestamp', 'desc')
            .limit(limit);
        if (!clearItems && items.length > 0) {
            const lastPost = items[items.length - 1];
            query.startAfter(lastPost);
        }
        if (!includeHidden) {
            query.where(['visible', '==', true]);
        }
        for (const clause of where) {
            query.where(clause);
        }
        const results = await query.run();
        if (nonce == token) {
            reachedEnd = results.length < limit;
            items = clearItems ? results : [...items, ...results];
            loading = false;
        }
    }

    async function nextPage() {
        if (!reachedEnd) {
            fetchData($isAdmin, false);
        }
    }

    $: fetchData($isAdmin, true);
</script>

<style lang="scss">
    .load-more {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
    }
</style>

{#if items}
    {#each items as item (item.__meta__.id)}
        <slot {item}/>
    {/each}
    {#if items.length === 0}
        <slot name="empty">
            <div class="subtle centered" transition:slide={{duration: 200}}>
                No content found... Maybe try another page?
            </div>
        </slot>
    {:else}
        {#if reachedEnd}
            <div transition:slide={{duration: 200}} class="subtle centered">
                You've reached the end! 🎉
                {#if items.length > 50}
                <br>Maybe you should get a new hobby... 🤔
                {/if}    
            </div>
        {:else}
            <div class="load-more">
                <button transition:slide={{duration: 200}} type="button" disabled={loading} on:click={nextPage}>Load more...</button>
            </div>
            <InfiniteScroll window={true} threshold={100} on:loadMore={nextPage} />
        {/if}
    {/if}
{/if}

{#if loading}
    <Spinner/>
{/if}
